/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const TypeEnum = {
  Text: "text",
  Checkbox: "checkbox",
  KeyValueMap: "key_value_map",
  Select: "select",
} as const;
export type TypeEnum = ClosedEnum<typeof TypeEnum>;

export type Option = {
  label: string;
  value: string;
};

export type DestinationSchemaField = {
  /**
   * The config key used to store and retrieve the field value. Matches the key in the destination's config or credentials object.
   */
  key: string;
  type: TypeEnum;
  label?: string | undefined;
  description?: string | undefined;
  required: boolean;
  /**
   * Indicates if the field contains sensitive information.
   */
  sensitive?: boolean | undefined;
  /**
   * Default value for the field.
   */
  default?: string | undefined;
  /**
   * Minimum length for a text input.
   */
  minlength?: number | undefined;
  /**
   * Maximum length for a text input.
   */
  maxlength?: number | undefined;
  /**
   * Regex pattern for validation (compatible with HTML5 pattern attribute).
   */
  pattern?: string | undefined;
  /**
   * Available options for select fields.
   */
  options?: Array<Option> | undefined;
};

/** @internal */
export const TypeEnum$inboundSchema: z.ZodNativeEnum<typeof TypeEnum> = z
  .nativeEnum(TypeEnum);
/** @internal */
export const TypeEnum$outboundSchema: z.ZodNativeEnum<typeof TypeEnum> =
  TypeEnum$inboundSchema;

/** @internal */
export const Option$inboundSchema: z.ZodType<Option, z.ZodTypeDef, unknown> = z
  .object({
    label: z.string(),
    value: z.string(),
  });
/** @internal */
export type Option$Outbound = {
  label: string;
  value: string;
};

/** @internal */
export const Option$outboundSchema: z.ZodType<
  Option$Outbound,
  z.ZodTypeDef,
  Option
> = z.object({
  label: z.string(),
  value: z.string(),
});

export function optionToJSON(option: Option): string {
  return JSON.stringify(Option$outboundSchema.parse(option));
}
export function optionFromJSON(
  jsonString: string,
): SafeParseResult<Option, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => Option$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'Option' from JSON`,
  );
}

/** @internal */
export const DestinationSchemaField$inboundSchema: z.ZodType<
  DestinationSchemaField,
  z.ZodTypeDef,
  unknown
> = z.object({
  key: z.string(),
  type: TypeEnum$inboundSchema,
  label: z.string().optional(),
  description: z.string().optional(),
  required: z.boolean(),
  sensitive: z.boolean().optional(),
  default: z.string().optional(),
  minlength: z.number().int().optional(),
  maxlength: z.number().int().optional(),
  pattern: z.string().optional(),
  options: z.array(z.lazy(() => Option$inboundSchema)).optional(),
});
/** @internal */
export type DestinationSchemaField$Outbound = {
  key: string;
  type: string;
  label?: string | undefined;
  description?: string | undefined;
  required: boolean;
  sensitive?: boolean | undefined;
  default?: string | undefined;
  minlength?: number | undefined;
  maxlength?: number | undefined;
  pattern?: string | undefined;
  options?: Array<Option$Outbound> | undefined;
};

/** @internal */
export const DestinationSchemaField$outboundSchema: z.ZodType<
  DestinationSchemaField$Outbound,
  z.ZodTypeDef,
  DestinationSchemaField
> = z.object({
  key: z.string(),
  type: TypeEnum$outboundSchema,
  label: z.string().optional(),
  description: z.string().optional(),
  required: z.boolean(),
  sensitive: z.boolean().optional(),
  default: z.string().optional(),
  minlength: z.number().int().optional(),
  maxlength: z.number().int().optional(),
  pattern: z.string().optional(),
  options: z.array(z.lazy(() => Option$outboundSchema)).optional(),
});

export function destinationSchemaFieldToJSON(
  destinationSchemaField: DestinationSchemaField,
): string {
  return JSON.stringify(
    DestinationSchemaField$outboundSchema.parse(destinationSchemaField),
  );
}
export function destinationSchemaFieldFromJSON(
  jsonString: string,
): SafeParseResult<DestinationSchemaField, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DestinationSchemaField$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DestinationSchemaField' from JSON`,
  );
}
